import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import toast from "react-hot-toast";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { uploadImagecertifates } from "../../../Redux/Actions/Action";
import { IoIosCloseCircle } from "react-icons/io";

function CategoryAddC() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  // Handle image upload
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.match(/image\/(jpg|jpeg|png|webp|gif)/i)) {
      toast.error("Please upload a valid image file (JPG, PNG, WEBP, GIF)");
      return;
    }

    setLoading(true);
    try {
      const uploadedImageUrl = await dispatch(uploadImagecertifates(file));
      setImage(uploadedImageUrl);
      setValue("categoryIcon", uploadedImageUrl);
      toast.success("Image uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Failed to upload image");
    }
    setLoading(false);
  };

  // Remove uploaded image
  const handleRemoveImage = () => {
    setImage(null);
    setValue("categoryIcon", "");
  };

  // Function to handle form submission
  const onSubmit = async (data) => {
    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");
      const payload = {
        categoryName: data.categoryName,
        description: data.description || "",
        categoryIcon: data.categoryIcon || "",
      };
      
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/category/`,
        payload,
        { headers: { Authorization: token } }
      );
      
      if (response.status === 200 || response.status === 201) {
        navigate("/category-management");
        toast.success("Category added successfully!");
      }
    } catch (error) {
      console.error("Error adding category:", error);
      toast.error(error.response?.data?.message || "Failed to add category");
    }
  };

  return (
    <>
      <div className="card-body">
        <form className="row" onSubmit={handleSubmit(onSubmit)}>
          <div className="col-sm-6">
            <div className="form-group text-start">
              <label className="form-label">Category Name</label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter category name"
                {...register("categoryName", {
                  required: "Category name is required.",
                })}
              />
              {errors.categoryName && (
                <p className="text-danger">{errors.categoryName.message}</p>
              )}
            </div>
          </div>

          {/* Image Upload Field */}
          <div className="col-sm-6">
            <div className="form-group text-start">
              <label className="form-label">Category Image</label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.webp,.gif"
                className="form-control"
                onChange={handleImageUpload}
                disabled={loading}
              />
              {loading && (
                <small className="text-muted d-block mt-2">Uploading...</small>
              )}
              <div className="mt-3">
                {image ? (
                  <div className="position-relative d-inline-block">
                    <img
                      src={image}
                      alt="uploaded"
                      style={{
                        width: "200px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-sm bg-transparent border-0 position-absolute top-0 end-0"
                      onClick={handleRemoveImage}
                      style={{ padding: "0" }}
                    >
                      <IoIosCloseCircle size={26} color="#727070" />
                    </button>
                  </div>
                ) : (
                  <div
                    style={{
                      width: "200px",
                      height: "150px",
                      border: "2px dashed #ccc",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#999",
                    }}
                  >
                    No image selected
                  </div>
                )}
              </div>
              <input
                type="hidden"
                {...register("categoryIcon")}
              />
            </div>
          </div>

          {/* Textarea Field */}
          <div className="col-12">
            <div className="form-group text-start">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows="4"
                placeholder="Enter category description"
                {...register("description")}
              />
            </div>
          </div>

          <div className="col-12 mt-4">
            <button 
              type="submit" 
              className="btn btn-primary text-uppercase px-5"
              disabled={loading}
            >
              {loading ? "SAVING..." : "SAVE"}
            </button>
            <Link 
              to="/category-management" 
              type="button" 
              className="btn btn-primary text-uppercase px-5 mx-2"
            >
              CANCEL
            </Link>
          </div>
        </form>
      </div>
    </>
  );
}

export default CategoryAddC;